// Type-safe wrapper for Google Analytics
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

/**
 * Track a page view in Google Analytics
 * @param url - The full URL path including search params (e.g., "/my-cards?tab=want-list")
 */
export const trackPageView = (url: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-NKKX593FTB', {
      page_path: url,
    });
  }
};

/**
 * Track a custom event in Google Analytics
 * @param eventName - Name of the event (e.g., "trade_completed", "card_added")
 * @param eventParams - Optional parameters for the event
 *
 * @example
 * trackEvent('trade_completed', {
 *   trade_value: 50.00,
 *   card_count: 5
 * });
 */
export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, any>
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};
